<template>
  <v-row class="news">
    <v-col class="col-12 col-lg-5 pa-0 pr-lg-6 mb-8 mb-lg-0">
      <swiper class="swiper" ref="swiper" :options="options">
        <swiper-slide v-for="(item, index) in latestNews" :key="index">
          <CloudImage class="img" :cloud-path="item.imgSrc" cover transition="fade" gradient="to bottom, rgba(0,0,0, 0), rgba(0,0,0,.7)"></CloudImage>
          <div class="wrapper d-flex flex-column justify-end pa-6">
            <div class="title mb-4">{{item.title}}</div>
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </v-col>
    <v-col class="col-12 col-lg-7 pa-0 mb-8 mb-lg-0">
      <Card class="card news" head title="新闻资讯" @more="more">
        <div class="head mb-5 d-flex align-stretch justify-space-between">
        </div>
        <NewsList :list="latestNews" @clickItem="newsItemOnClick" @hoverItem="newsItemHover"></NewsList>
      </Card>
    </v-col>
  </v-row>
</template>

<script>
import Card from '@/components/UI/Card'
import NewsList from '@/components/UI/List'
import CloudImage from '@/components/News/CloudImage'
import { LatestNews } from '@/mixins/news'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
  name: 'News',
  mixins: [LatestNews],
  components: {
    Card,
    NewsList,
    CloudImage,
    Swiper,
    SwiperSlide
  },
  data: () => ({
    options: {
      autoplay: true,
      grabCursor: true
    }
  }),
  computed: {
    swiper () {
      return this.$refs.swiper.$swiper
    }
  },
  mounted () {
    this.getLatestNews()
  },
  methods: {
    more () {
      this.$router.push('/news')
    },
    newsItemHover ({ index }) {
      if (this.swiper.activeIndex !== index) {
        this.swiper.slideTo(index, 1000, false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.news {
  .btn-more {
    height: auto;
  }
  .swiper {
    width: 100%;
    height: 400px;
    .wrapper {
      position: relative;
      width: 100%;
      height: 100%;
      z-index: 2;
      box-sizing: border-box;
      color: #FFF;
    }
    .img {
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 1;
    }
  }
}
</style>
